import { TranslationObject } from '@ngx-translate/core';

const en: TranslationObject = {
  en: 'English',
  app: {
    title: 'Pre-Startup Safety Review',
    forms: {
      ok: 'Ok',
      cancel: 'Cancel',
      create: 'Create',
      continue: 'Continue',
      selectAll: 'Select All',
      save: 'Save',
      labels: {
        businessUnit: 'Business Unit',
        placeholderBusinessUnit: 'Select a business unit',
        organization: 'Organization',
        placeholderOrganization: 'Select an organization',
        user: 'User',
        name: 'Name',
        description: 'Description',
        displayRichEditor: 'Display rich editor',
        placeHolderDescription: 'Enter a description',
        placeHolderReviewType: 'Select a review type',
        mandatory: 'Mandatory',
        isActive: 'Active',
      },
      categories: {
        placeholders: {
          categoryName: 'Category name',
        },
      },
      unsavedChangesWarning:
        'Unsaved changes have been detected. If you leave this page, the modifications you made will be lost.<br>Do you want to continue?',
      validation: {
        required: '{{controlName}} is required',
        invalidEmail: 'Please enter a valid email address',
      },
    },
    warnings: {
      removeOwnAdminRights: 'You have removed your admin rights. Please refresh the web page to prevent misfunction.',
      removeOwnAccess: 'You have removed your access. Please refresh the web page to prevent misfunction.',
    },
  },
  header: {
    support: 'Support',
    userGuide: 'User Guide',
  },
  navigation: {
    pssrs: '{{pssrTitle}}s',
    projects: 'Projects',
    actionsItems: 'Action Items',
    administration: 'Administration',
    hierarchyManagement: 'Hierarchy Management',
    businessUnits: 'Business Units',
    organizations: 'Organizations',
    facilityHierarchy: 'Facility Hierarchy',
    accessManagement: 'Access Management',
    organizationUsers: 'Users',
    buAdmins: 'BU User admins',
    userGroups: 'Action item user groups',
    systemAdmins: 'System administrators',
    pssrConfiguration: 'PSSR Configuration',
    templates: 'PSSR checklists',
    categories: 'Business Unit Categories',
  },
  functionalReviewList: {
    title: 'Functional Review',
    mocTitle: 'MOC:',
    noFunctionalReview: 'No Functional Review',
    id: 'ID',
    code: 'Code',
    question: 'Question',
    answer: 'Answer',
    comment: 'Comment',
    updatedBy: 'Updated By',
    updatedDate: 'Updated Date',
    createNewFunctionalReview: 'create new functional review',
    reviewType: 'Review Type',
    addQuestion: 'Add Question',
    description: 'Description',
    subSection: 'Sub Section',
    clearAnswer: 'Clear Answer',
    deleteQuestion: 'Delete Question',
    deleteQuestionTitle: 'Delete Question',
    confirmDeleteQuestion:
      '<span>Are you sure you want to delete this question?</span><br><br><span><b>Question:</b> {{ description }}</span>',
    generateReport: 'Generate Report',
    completeReview: 'Complete Review',
    generateSuccessMessage: 'Report generated successfully',
    reviewSuccessMessage: 'Functional Review completed successfully',
  },
  admin: {
    sysAdminList: {
      title: 'System Administrators',
      addSysAdmin: 'add administrator',
      fullName: 'full name',
      disabled: 'disabled',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmation',
        removeAccessMessage: 'Are you sure you want to remove system admin access for: [{{fullName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Business Units',
      addBusinessUnit: 'Add business unit',
      tableTitle: 'Business unit',
    },
    businessUnitCreate: {
      title: 'Create Business Unit',
    },
    businessUnitEdit: {
      title: 'Edit Business Unit',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Support Information',
          name: 'Name',
          businessUnitSupportInfo: 'Business Unit Support Information',
          businessUnitSupportInfoDescription: 'This information will be displayed on the support page',
          displayRichEditor: 'display rich editor',
        },
        approvalForAccess: {
          titleApproval: 'Approval for Access',
          userNeedsBuAdmin: 'User needs BU admin to grant access',
          userGetsInstantAccess: 'User will get instant access',
        },
        labels: {
          titleLabels: 'Labels',
          hierarchyLabel1: 'Hierarchy Label 1',
          hierarchyLabel2: 'Hierarchy Label 2',
          hierarchyLabel3: 'Hierarchy Label 3',
          pssrLabel: 'PSSR Label',
          organizationLabel: 'Organization Label',
          eventNameLabel: 'Event Name Label',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'default is \'project\'',
          show: 'show',
        },
        pssrConfigurations: {
          titleConfigurations: 'PSSR Configurations',
          stagnantPssrInterval: 'Stagnant PSSR Interval',
          instructions: 'Instructions',
          instructionsDescription: 'Stagnant general instructions for PSSR',
          showProject: 'Do you want to show Project?',
          projectDisplayType: 'How do you want to show Project?',
          dropdown: 'Dropdown',
          input: 'Input',
          showKms: 'Do you want to show KMS? A "pull from KMS" button will display when creating a new PSSR.',
          showQaqcModule: 'Do you want to show QAQC Module at Project? Requires project to be enabled.',
          showWetSignatureApproval:
            'Do you want to allow a PSSR wet signature? This allows the Operations Representative to approve the PSSR at pending approval status. The button that says "approve by wet signature."',
          pssrTypesToShow: 'Which PSSR Types do you want to show?',
          showPssrType: 'Show PSSR Type',
          ccc: 'CCC',
          factory: 'Factory',
          moc: 'MOC',
          nonMoc: 'NON-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Test',
          showNaResponse:
            'Do you want to allow users to respond N/A? If you select no, it would require comment or action item to be consider completed.',
          sendScheduledEmail:
            'Do you want to send a scheduled email every Monday at 8:00 AM CST to users with pending action items?',
          showConstructionComplete:
            'Do you want to show Construction Complete Certificate (CCC) for some headers/titles/labels?',
          showOperationReadiness:
            'Do you want to display Operation Readiness Review (ORR) for some headers/titles/labels?',
          showVerbalApproval:
            'Do you want to show verbal approval? This displays a input in the mobile app to manually write who is approving. This doesn\'t cause any action and can be performed by the lead or approver.',
          allowLeadToDelete: 'Do you want to allow lead to delete questions for a PSSR on draft or initiated status?',
          allowTeamMemberActions:
            'Do you want to allow any team member to answer questions, sign questions and create action items up until it is approved?',
          restrictMocWo:
            'Do you want to restrict MOCWO project number? If you select "yes", MOC and WO are required to create a PSSR.',
          allowLeadsToShare:
            'Do you want to allow Leads to share device with approvers? If you select "yes" the lead can share the device with the approver if the approver is present to sign.',
          requireFinalApprovalBeforeInitiation:
            'Do you want to require final approval before initiation? If "yes" the PSSR will require to have a final approver to initiate it.',
          allowFinalApproverNotifications: 'Do you want to allow the final approver to receive all notifications?',
          allowFinalApproverSubmit: 'Do you want to allow final approver to submit for approval?',
          allowMultiplesApprovers: 'Do you want to allow multiple approvers?',
          ShowSectionsCollapsed: 'Do you want collapse PSSR sections when editing?',
          requireActionItemDueDate: 'Do you want to require a due date for action items?',
          limitAccessToAIOwner:
            'Do you want to restrict the action item owner or assignee from modifying the description, changing the due date, or deleting the action item?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Action Item Configurations',
          sendToMoc: 'Do you want to send action items to MOC?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Do you want to allow team lead to attach and modify an action item? If you select "yes", leads can only attach files, assignee, status and comment after pending approval.',
          allowActionItemOwnerAttach:
            'Do you want to allow the action item owner to attach at any status while PSSR is not closed?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Not Registered',
      forms: {
        submit: 'Request Access',
      },
      dialogTitle: 'Request Access',
      dialogSubtitle: 'You are about to request access for <strong>{{Name}}</strong>, you want to proceed?',
      reloadWarning:
        'If you visit this page but already have access, please click the following link to reload, otherwise contact support.',
      reload: 'reload',
    },
    pendingAccess: {
      title: 'Hi, your Access Request is in Progress',
      reloadWarning:
        'If you visit this page but already have access, please click the following link to reload, otherwise contact support.',
      reload: 'reload',
    },
  },
  footer: {
    text: 'Chevron Corporation. All rights reserved.',
  },
  checklist: {
    title: 'PSSR Checklist',
    create: 'create new',
    hideCode: 'hide code',
    code: 'Code',
    name: 'Checklist Name',
    edit: 'edit',
    manage: 'manage',
    delete: 'delete',
    noChecklists: 'No checklists available.',
    defaultWalkthroughDisclaimer: 'Default Walkthrough Signature Disclaimer',
    defaultSummaryDisclaimer: 'Default Summary Signature Disclaimer',
    displayRichEditor: 'display rich editor',
    sampleText: 'sample text',
    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Are you sure you want to delete [{{description}}]?',
    },
    titleCreate: 'Create Checklist',
    createNew: 'Create New',
    selectPlaceholder: 'Select one...',
    titleEdit: 'Edit Checklist',
    titleDelete: 'Delete Checklist',
    deletedSuccessfully: 'Checklist deleted successfully',
    importChecklist: 'Import Checklist',
    importChecklistTitle: 'Import Checklist to ',
    selectChecklistType: 'Select Checklist Type',
    confirm: 'Confirm',
    importSuccessMessage: 'Checklist imported successfully',
  },
  checklistManage: {
    title: 'Manage [{{ Description }}]',
    sectionsTitle: 'Sections',
    addSectionAction: 'add section',
    mandatoryLabel: 'Mandatory',
    createNewSubsectionAction: 'create new subsection',
    emptySubSectionsMessage:
      '<p>There is no content available for this section.</p><p>Please add a subsection to start.</p>',
    itemCodeTableHeader: 'code',
    itemDescriptionTableHeader: 'description',
    createNewItemAction: 'create new item',
    createSectionHeader: 'Create Section',
    editSectionHeader: 'Edit Section',
    confirmDeleteSection: 'Are you sure you want to delete the section <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Create subsection',
    editSubSectionHeader: 'Edit subsection',
    createChecklistItemTitle: 'Create Checklist Item',
    editChecklistItemTitle: 'Edit Checklist Item',
    ShouldAddCommentToQuestion: 'The user should add a comment to any question answered with N/A',
    autoGenerateCodeLabel: 'Auto-generate code',
    autoGenerateCodeplaceholder: 'Code will be auto-generated',
    autoGenerateCodeInfo: 'Auto-generation has been activated, the field will be automatically filled',
    deleteChecklistItemTitle: 'Delete Checklist Item',
    confirmDeleteChecklistItem:
      '<span>Are you sure you want to delete this checklist item?</span><br><br><span><b>Code:</b> {{ name }}<br><b>Description:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Are you sure you want to delete the subsection <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Delete Section',
    deleteSubSectionHeader: 'Delete Subsection',
    editQuestionTitle: 'Edit Question',
    sectionTypeLabel: 'Section Type',
    sectionTypePlaceholder: 'Select a section type',
    subSectionNameLabel: 'Subsection Name',
    itemTypeLabel: 'Type',
    itemTypePlaceholder: 'select one',
    codePlaceholder: 'Enter code',
    duplicateCodeError: 'This code is already used in another section.',
    displayRichEditorLabel: 'Display rich editor',
    requireCommentForNA: 'Do you want to require a comment for a N/A question?',
  },
  common: {
    yes: 'Yes',
    no: 'No',
    na: 'N/A',
    save: 'Save',
    saving: 'Saving...',
    businessUnit: 'Business Unit',
    name: 'Name',
    code: 'Code',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    forbidActionErrorMessage: 'User is not authorized to perform this action',
    genericErrorMessage: 'An unexpected error has occurred. Please try again later.',
    errorOccurred: 'An error occurred. Please try again.',
    savedSuccessfully: 'Saved successfully',
    createdSuccessfully: 'Created successfully',
    delete: 'Delete',
    deletedSuccessfully: 'Deleted successfully',
    edit: 'Edit',
    leaveWithOutSaving: 'Leave without saving',
    language: 'Language',
    month: 'Month',
    months: 'Months',
    loading: 'Loading...',
    all: 'All',
    recordAlreadyExists: 'The record entered already exists',
    recordCreatedSuccessfully: 'Record created successfully',
  },
  paginator: {
    previous: 'Previous',
    next: 'Next',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} of {{totalRecords}}',
  },
  usersList: {
    title: 'Users',
    forms: {
      displayInactiveUsers: 'display inactive users',
      search: 'Search',
    },
    actions: {
      addNewUser: 'Add new user',
      grantAccess: 'grant access',
      reimportAllSharedUsers: 'Re-import All Shared Users',
    },
    table: {
      fullName: 'full name',
      email: 'email',
      admin: 'admin',
      type: 'type',
    },
    noUsers: 'No users available',

    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Are you sure you want to remove access for: [{{fullName}}]?',
      addUserHeader: 'Add new user',
      editUserHeader: 'Edit user',
      reimportSharedUsersHeader: 'Re-import All Shared Users',
      reimportSharedUsersMessage:
        'You are about to update all shared users configuration.<br> This operation could take several minutes to complete.',
    },
    messages: {
      importSharedUsersFailed: 'Import failed',
      importSharedUsersIncompleted: 'Import incomplete',
      importSharedUsersCompleted: 'Import complete in: {{ minutes }}mins',
      pleaseWaitUntilProcessEnds:
        'Please wait until the import process is complete. Do not close or navigate away from this page.',
      importInProgress: 'Import is in progress. Please wait until it completes before closing the page.',
      calculatingProgress: 'Calculating progress...',
    },
    labels: {
      imported: 'Imported',
      notFound: 'Not Found',
      errors: 'Errors',
      total: 'Total',
    },
  },
  comments: {
    title: 'Comments',
    addComment: 'add comment',
    dialogs: {
      configureComment: 'Comment',
      deleteCommentHeader: 'Delete Comment',
      deleteCommentMessage: 'Are you sure that you want to perform this action?',
    },
    comment: 'Comment',
  },
  actionItems: {
    title: 'Action Items',
    id: 'ID',
    addActionItem: 'Add Action Item',
    noActionItems: 'No action items available',
    canOnlyPerformAttachments: 'You can only manage file attachments. Other action item properties cannot be edited.',
    actionTitle: 'Title',
    assignee: 'Assignee',
    date: 'Date',
    dueDate: 'Due Date',
    category: 'Category',
    primaryCategory: 'Primary Category',
    secondaryCategory: 'Secondary Category',
    subcategory: 'Subcategory',
    comment: 'Comment',
    editComment: 'Edit Comment',
    commentRequiredWhenClosed: 'Comment is required when status is set to Closed',
    priority: 'Priority',
    assignTo: 'Assign to',
    pssrCccMembers: '{{pssrTitle}} Members',
    chevronDirectory: 'Chevron directory',
    userGroup: 'User group',
    other: 'Other',
    status: 'Status',
    statusNames: {
      Open: 'Open',
      Closed: 'Closed',
      Cancel: 'Cancelled',
      Rejected: 'Rejected',
    },
    createdBy: 'Created by',
    updatedDate: 'Updated date',
    updatedBy: 'Updated by',
    selectOne: 'Select one...',
    typeNameOrEmail: 'Type name or email...',
    inactive: 'Inactive',
    reopen: 'Reopen',
    reject: 'Reject',
    rejectReason: 'Rejection Reason',
    rejectReasonPlaceholder: 'Enter reason for rejection',
    timeCaptured: 'Time Captured',
    attachments: 'Attachments',
    pssrFiles: 'PSSR Files',
    links: 'Links',
    fileUpload: 'File Upload',
    attachFiles: 'Attach (docs, images, etc.)',
    fileTooLarge: 'File \'{{name}}\' exceeds the maximum allowed size of {{max}}.',
    invalidFileFormat: 'File \'{{name}}\' has an unsupported format.',
    duplicateFile: 'File \'{{name}}\' has already been added.',
    linkPlaceholder: 'www.example.com',
    dialogs: {
      configureActionItem: 'Configure Action Item',
      configureComment: 'Comment',
      deleteActionItemHeader: 'Delete Action Item',
      deleteActionItemMessage: 'Are you sure that you want to perform this action?',
      rejectActionItemHeader: 'Reject Action Item',
      confirmPriorityChangeHeader: 'Confirm Priority Change',
      confirmPriorityChangeMessage: 'Are you sure you want to change the priority of this action item?',
      deleteAttachmentHeader: 'Delete Attachment',
      deleteAttachmentMessage: 'Are you sure you want to delete this attachment?',
    },
    messages: {
      deleteSuccess: 'Action item deleted successfully',
      reopenSuccess: 'Action item reopened successfully',
      rejectSuccess: 'Action item rejected successfully',
      rejectReasonRequired: 'Reject reason is required',
      confirmReject: 'Are you sure you want to reject this action item? It will {{action}}.',
      confirmRejectP4: 'Are you sure you want to reject this action item?',
      returnToTeamLead: 'return to Team Lead',
      confirmReopen: 'Are you sure you want to reopen this action item?',
    },
  },
  actionItemsList: {
    title: 'Action Items',
    sections: {
      location: 'Location',
      pssr: 'PSSR',
      actionItem: 'Action Item',
    },
    fields: {
      area: 'Area',
      facilityOperationTeam: 'Facility Operation Team',
      facility: 'Facility',
      titleStatus: 'Title Status',
      type: 'Type',
      title: 'Title',
      project: 'Project',
      template: 'Template',
      leadFinalApprover: 'Lead/Final Approver',
      showOnlyDeletedPssr: 'Show Only Deleted PSSR',
      status: 'Status',
      priority: 'Priority',
      assignedTo: 'Assigned to',
      autoLoadImages: 'Auto-Load Images',
    },
    placeholders: {
      selectOne: 'select one',
      sampleText: 'sample text',
      no: 'Select No',
    },
    priorityDescriptions: {
      p3: 'Item must be completed before start up',
      p4: 'Item will be complete after start up',
      p5: 'Item must be completed before start up',
    },
    priorityLegend: {
      title: 'Action Item Priorities',
    },
    actions: {
      clearFilter: 'clear filter',
      exportExcel: 'export excel',
      noDataToExport: 'No action items to export',
    },
    imageAltText: 'Action Item Image',
    pssrTeamLead: 'PSSR Team Lead',
    finalApprover: 'Final Approver',
    subsection: 'Subsection',
    code: 'Code',
    question: 'Question',
    answer: 'Answer',
    noData: 'No action items available',
    noDataFound: 'No action items found for the selected filters',
  },
  responseSignature: {
    signedBy: 'Signed By',
    signedOn: 'Signed On',
    name: 'Name',
    dateCaptured: 'Date Captured',
    sign: 'Sign',
    finalApproverLabel: 'Final Approver',
    dialogs: {
      deleteHeader: 'Delete signature',
      deleteMessage: 'You are about to delete signature, please select confirm to proceed',
      cancel: 'cancel',
      delete: 'delete',
    },
  },
  userType: {
    Chevron: 'Chevron',
    External: '3rd Party (external)',
    Shared: 'Shared',
  },
  areas: {
    title: 'Area',
    showDeletedItems: 'Show Deleted Items',
    areaListTitle: 'Area List',
    createFacilityOperationTeam: 'Create New Facility Operation Team',
    createFacility: 'Create New Facility',
    restore: 'Restore',
    emptySubAreaMessage:
      '<p>There is no content available for this area.</p><p>Please add a new facility operation team to start.</p>',
    emptyHierarchyChildrenMessage:
      '<p>There is no <strong>{{childLabel}}</strong> available for this <strong>{{parentLabel}}</strong>.</p><p>Please add a new <strong>{{childLabel}}</strong> to start.</p>',
    emptyAreaMessage:
      '<p>There is no content available for this business unit.</p><p>Please add a new area to start.</p>',
    subareaTitle: 'Facility Operation Team',
    facilityTitle: 'Facility',
    removeConfirmationHeader: 'Confirmation',
    confirmDeleteArea: 'Are you sure you want to delete the Area <strong>{{description}}</strong>?',
    confirmDeleteSubarea:
      'Are you sure you want to delete the Facility Operation Team <strong>{{description}}</strong>?',
    confirmDeleteFacility: 'Are you sure you want to delete the Facility <strong>{{description}}</strong>?',
    restoredSuccessfully: 'Restored Successfully',
  },
  organizationsList: {
    title: 'Organizations',
    tableHeader: 'organization',
    noOrganizations: 'No organizations available',
    successCreated: 'Organization created successfully',
    actions: {
      addNew: 'add new organization',
    },
    forms: {
      name: 'Organization Name',
      namePlaceholder: 'type organization name',
    },
    dialogs: {
      addNew: 'Add New Organization',
      edit: 'Edit Organization',
      deleteHeader: 'Delete Organization',
      deleteMessage: 'Are you sure you want to delete the organization: [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Action Item User Groups',
    groupsSection: 'Groups',
    noUsers: 'No users in this group',
    noGroups: 'No groups available',
    selectGroup: 'Select a group to view users',
    actions: {
      create: 'create',
      addNewUser: 'add new user',
      selectUser: 'Select User',
      changeUser: 'Change User',
      add: 'Add',
    },
    table: {
      userName: 'user name',
      email: 'email',
    },
    forms: {
      namePlaceholder: 'Enter group name',
      selectUserPrompt: 'Please select a user to add to this group',
      selectedUser: 'Selected User',
    },
    dialogs: {
      addGroup: 'Add New Group',
      editGroup: 'Edit Group',
      deleteGroupHeader: 'Delete Group',
      deleteGroupMessage: 'Are you sure you want to delete the group: [{{name}}]?',
      removeUserHeader: 'Remove User',
      removeUserMessage: 'Are you sure you want to remove {{name}} from this group?',
      addUser: 'Add User to Group',
      selectUser: 'Select User',
    },
  },
  pssrImport: {
    title: 'Import MOC',
    sections: {
      import: 'Import',
    },
    forms: {
      labels: {
        application: 'Application',
        pssrId: 'ID',
        mocId: 'MOC ID',
        mocName: 'MOC Name',
      },
      placeholders: {
        application: 'select one',
        pssrId: 'Enter MOC ID',
        mocName: 'Auto-populated from iMOC',
      },
      validation: {
        mocIdRequired: 'MOC ID is required',
        applicationRequired: 'Application is required',
      },
    },
    actions: {
      add: 'Add',
      addMoc: 'Add MOC',
      importAll: 'Import All',
      createPssr: 'create PSSR',
      searchMoc: 'search MOC',
      importMocCreatePssr: 'Import MOC & Create PSSR',
    },
    table: {
      id: 'ID',
      pssrId: 'PSSR ID',
      name: 'Name',
      status: 'Status',
    },
    summary: {
      records: 'Records',
      imported: 'Imported',
      errors: 'Errors',
    },
    status: {
      pending: 'Pending',
      inProgress: 'In Progress',
      imported: 'Imported',
      warning: 'Warning',
      error: 'Error',
    },
    messages: {
      alreadyInList: 'PSSR ID is already in the import list.',
      pssrNotFound: 'PSSR not found.',
    },
  },
  pssrCreate: {
    title: 'Create PSSR',
    sections: {
      generalInformation: 'General Information',
      location: 'Location',
      details: 'Details',
      instructions: 'Instructions',
    },
    forms: {
      labels: {
        title: 'Title',
        moc: 'MOC',
        wo: 'WO',
        description: 'Description',
        area: 'Area',
        facilityOperationTeam: 'Facility Operation Team',
        facility: 'Facility',
        project: 'Project',
        template: 'Template',
        type: 'Type',
        organization: 'Organization',
        subArea: 'Sub Area',
        includeProjectTeam: 'Include Project Team Members',
      },
      placeholders: {
        title: 'sample text',
        moc: 'sample text',
        wo: 'sample text',
        description: 'Enter description here (max 5000 characters)',
        area: 'select one',
        facilityOperationTeam: 'select one',
        facility: 'select one',
        project: 'select one',
        template: 'select one',
        type: 'select one',
        subArea: 'select one',
      },
      validation: {
        titleRequired: 'Title is required',
        mocRequired: 'MOC is required',
        woRequired: 'WO is required',
        businessUnitRequired: 'Business Unit is required',
        organizationRequired: 'Organization is required',
        areaRequired: 'Area is required',
        facilityOperationTeamRequired: 'Facility Operation Team is required',
        facilityRequired: 'Facility is required',
        projectRequired: 'Project is required',
        templateRequired: 'Template is required',
        typeRequired: 'Type is required',
      },
    },
    actions: {
      create: 'create',
      pullFromKMS: 'Pull from KMS',
    },
    successMessage: 'PSSR created successfully',
  },
  pssrKms: {
    title: 'PSSR from KMS',
    sections: {
      generalInformation: 'General Information',
      pssrInformation: 'PSSR Information',
      location: 'Location',
      details: 'Details',
    },
    kmsInstruction:
      'Search for a specific MOC number or filter the list by status and page size to import data from KMS.',
    searchMOCNumber: 'Search MOC Number',
    mocPattern: 'e.g., MOC-2024-123',
    invalidMOCFormat: 'Invalid MOC format. Example: MOC-2024-123',
    search: 'Search',
    filterByStatus: 'Filter KMS List by Status',
    filterPageSize: 'Filter Number of KMS Items returned',
    selectFromList: 'Select From KMS MOC List',
    selectKMSItems: 'Select KMS items',
    createNew: 'Create New',
    enterName: 'Enter name',
    add: 'Add',
    enterProjectNumber: 'Enter project number',
    selectQAQCEvent: 'Select QAQC event',
    selectFromQAQC: 'Select from QAQC',
    milestones: 'QAQC Milestones',
    workOrders: 'QAQC Work Orders',
    selectMilestone: 'Select milestone',
    selectWorkOrder: 'Select work order',
    milestoneWorkOrders: 'Milestone Work Orders',
    note: 'Note',
    fillRequiredFields: 'Please fill up the fields that are marked required',
    generatePSSRs: 'Generate PSSRs',
    successMessage: 'PSSR from KMS created successfully',
    multipleSuccessMessage: 'Multiple PSSRs from KMS created successfully',
    loadingKMSItemsError: 'Error loading KMS items. Please try again.',
    selectKMSItemsWarning: 'Please select at least one KMS item',
    kmsStatus: {
      draft: 'Draft',
      processActivated: 'Process Activated',
      reviewInProgress: 'Review In Progress',
      implementationInProgressEdit: 'Implementation In Progress Edit',
      changeRequestApproved: 'Change Request Approved',
      changeRequestDenied: 'Change Request Denied',
      implementationInProgress: 'Implementation In Progress',
      readyToStartUp: 'Ready To Start Up',
      completed: 'Completed',
      canceled: 'Canceled',
      onHold: 'On Hold',
    },
    businessUnit: 'Business Unit',
    selectPlaceholder: 'Select one',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Add Question',
    },
  },
  pssrDetails: {
    title: 'PSSR Details',
    pssrId: 'PSSR ID',
    sections: {
      generalInformation: 'General Information',
      location: 'Location',
      details: 'Details',
      sectionsTitle: 'Sections',
      actionItems: 'Action Items',
      comments: 'Comments',
      enableCustomOrderForSections: 'Enable custom order for sections',
      sectionsLegendTitle: 'Sections Legend',
      hideCompletedQuestions: 'Hide Completed Questions',
      saveSectionOrder: 'Save Section Order',
      confirmRemoveSectionTitle: 'Remove Section',
      confirmRemoveSectionDescription: 'Are you sure you want to remove {{description}}?',
      sectionNameLabel: 'Section Name',
      sectionNamePlaceholder: 'Enter section name',
      editSectionName: 'Edit section name',
      addMultipleSectionName: 'Add multiple section',
      validation: {
        sectionNameRequired: 'Section name is required',
        sectionNameDuplicated: 'A section with this name already exists',
      },
      toast: {
        unableToCompleteOperation: 'Unable to complete operation',
        saveCompletedTitle: 'Save Completed',
        sectionsSortedSuccessfully: 'Sections were sorted successfully',
        sectionAddedSuccessfully: 'Section added successfully',
        sectionUpdatedSuccessfully: 'Section updated successfully',
        loadSectionsError: 'Error loading sections. Please try again.',
        userAlreadyAdded: 'User already added to this section',
        userAddedSuccessfully: 'User added successfully',
      },
      selectLead: 'select lead',
      section1Title: 'Section 1',
      legend: {
        defaultQuestionLabel: 'default question',
        defaultQuestionDescription: 'question that can be answered by yes, no or n/a',
        optionalLabel: 'optional',
        optionalDescription: 'can be added manually to pssr',
        multipleLabel: 'multiple',
        multipleDescription: 'optional but can be added multiple times pssr',
        mandatoryLabel: 'mandatory',
      },
      instructions: 'Instructions',
      history: 'History of PSSR changes',
      attachments: 'PSSR Attachments',
    },
    subsections: {
      actionItemNeeded: 'Note: Action item is needed to complete questions.',
    },
    questions: {
      code: 'Code',
      question: 'Question',
      answer: 'Answer',
      updatedBy: 'Updated By',
      updatedDate: 'Updated Date',
      clearAnswer: 'clear answer',
      deleteQuestion: 'delete question',
      answerUpdated: 'Answer updated successfully',
      answerCleared: 'Answer cleared successfully',
      questionDeleted: 'Question deleted successfully',
      confirmDeleteTitle: 'Delete Question',
      confirmDeleteMessage: 'Are you sure you want to delete this question: {{question}}?',
      validation: {
        actionItemIsNeeded: 'Action Item is needed to complete question',
        commentIsNeeded: 'Comment is needed to complete question',
        signatureIsNeeded: 'Signature is needed to complete question',
        responseIsNeeded: 'Response is needed to complete question',
        actionItemsClosedOrCancelledNeeded:
          'Action Item(s) closed or cancelled {{P3Label}} are needed to complete question',
      },
    },
    forms: {
      labels: {
        title: 'Title',
        moc: 'MOC',
        wo: 'WO',
        description: 'Description',
        area: 'Area',
        facilityOperationTeam: 'Facility Operation Team',
        facility: 'Facility',
        project: 'Project',
        template: 'Template',
        type: 'Type',
      },
      placeholders: {
        title: 'sample text',
        moc: 'sample text',
        wo: 'sample text',
        description: 'Enter description here (max 5000 characters)',
        area: 'select one',
        facilityOperationTeam: 'select one',
        facility: 'select one',
        project: 'select one',
        template: 'select one',
        type: 'select one',
      },
      validation: {
        titleRequired: 'Title is required',
        businessUnitRequired: 'Business Unit is required',
        organizationRequired: 'Organization is required',
        areaRequired: 'Area is required',
        facilityOperationTeamRequired: 'Facility Operation Team is required',
        facilityRequired: 'Facility is required',
        templateRequired: 'Template is required',
        typeRequired: 'Type is required',
        requiredFieldsMessage: 'Note: Please fill up the fields that are marked required. Please click Save.',
      },
      templateChangeConfirmTitle: 'Change Template',
      templateChangeConfirmMessage:
        'Changing the template will update the PSSR sections. Are you sure you want to change the template?',
    },
    mocImportedHint: 'This PSSR was imported. You cannot change its id',
    history: {
      reason: 'Reason',
      by: 'By',
      draftCreated: 'Draft Created On',
      initiated: 'Initiated On',
      started: 'Started On',
      completed: 'Completed On',
      pendingApproval: 'Pending Approval On',
      verbalApproval: 'Verbal Approval On',
      approved: 'Approved On',
      rejected: 'Rejected On',
      restored: 'Restored On',
      deleted: 'Deleted On',
      closed: 'Closed On',
    },
    actions: {
      save: 'save',
      saveGeneralInformation: 'save general information',
      showFullHistory: 'show full history',
      showLessHistory: 'show less history',
      attachFile: 'Attach file (documents, images, psi drawings, etc.)',
      attachFileButton: 'attach file',
      printToPdf: 'print to pdf',
      sendEmailReminder: 'send email reminder',
      importMocActionItems: 'import moc action items',
      sendToMocStartup: 'send to moc record for startup approval',
      returnToTeamLead: 'return to team lead',
      start: 'start pssr',
      reject: 'reject',
      delete: 'delete',
      restorePssr: 'restore pssr',
      reopen: 'reopen',
    },
    successMessage: 'PSSR updated successfully',
    pdfDownloadSuccess: 'PDF downloaded successfully',
    pssrDeletedSuccess: 'PSSR deleted successfully',
    pssrReopenedSuccess: 'PSSR reopened successfully',
    statusChangedSuccess: 'PSSR Status changed successfully',
    pssrRejectedSuccess: 'PSSR rejected successfully',
    pssrRestoredSuccess: 'PSSR restored successfully',
    importMOCActionsSuccess: 'MOC Action Items imported successfully',
    sendToMOCSuccess: 'Uploaded to MOC successfully',
    emailSentSuccess: 'Email reminder sent successfully',
    importMOCActionsNone: 'No MOC Action Items to import',
    lastSent: 'Last Sent',
    messages: {
      questionAdded: 'Question added successfully',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Enter question description',
        descriptionRequired: 'Description is required',
      },
    },
    rejectDialog: {
      title: 'Reject PSSR',
      reasonLabel: 'Rejection Reason',
      cancel: 'Cancel',
      confirm: 'Reject',
    },
    emailReminderDialog: {
      title: 'Send Email Reminder',
      sendReminder: 'Send Reminder',
      sendMessage: 'Send Custom Message',
      reminderInstructions:
        'Send reminder to assignees for all opened AIs. When PSSR is in Pending Approval status, Approvers will receive notification.',
      messageInstructions: 'Send an email message to all PSSR Participants',
      enterText: 'Enter your message...',
      cancel: 'Cancel',
      confirm: 'Send',
    },
    commentDialog: {
      title: 'Comment',
      commentLabel: 'Comment',
      commentPlaceholder: 'sample text',
      commentRequired: 'Comment is required',
      createdBy: 'Created by',
      updatedDate: 'Updated date',
      updatedBy: 'Updated by',
      documents: 'Documents',
      delete: 'delete',
      cancel: 'cancel',
      save: 'save',
      addComment: 'Add Comment',
      editComment: 'Edit Comment',
      confirmDelete: 'Are you sure you want to delete this comment?',
      confirmDeleteHeader: 'Delete Comment',
      confirmDeleteAttachment: 'Are you sure you want to delete this attachment?',
      confirmDeleteAttachmentHeader: 'Delete Attachment',
      commentAdded: 'Comment added successfully',
      commentUpdated: 'Comment updated successfully',
      commentDeleted: 'Comment deleted successfully',
    },
    confirmDeleteHeader: 'Confirm Delete',
    confirmDeleteMessage: 'You are about to delete this item. Do you want to continue?',
    confirmDeleteComment: 'Are you sure you want to delete this comment?',
    commentDeletedSuccess: 'Comment deleted successfully',
    changeStatusHeader: 'Confirm Change Status',
    confirmChangeStatus: 'Do you want to change status?',
    confirmReturnToTeamLead: 'Do you want to return this PSSR to the Team Lead?',
    confirmRejectHeader: 'Confirm Reject',
    confirmRejectMessage: 'Are you sure you want to reject this PSSR?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Are you sure you want to re-open this PSSR?',
    comments: {
      title: 'Comments',
      addComment: 'add comment',
      noComments: 'No comments added',
      by: 'by',
      on: 'on',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Only PSSR Team Lead can initiate PSSR',
      requireFinalApproverBeforeInitiation: 'Final Approver is required before initiating PSSR',
      pssrMustAnswerAllQuestionsToCompleteWalkdown:
        'All questions must be answered and all signatures must be captured to complete the walkdown',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'PSSR must have a Final Approver to complete the walkdown',
      onlyPSSRTeamLeadcanSubmitforPendingApproval: 'Only PSSR Team Lead can submit for pending approval',
      p3ActionItemsMustBeClosed: 'Priority 3 action items must be closed',
      p4ActionItemsMustBeClosed: 'Priority 4 action items must be closed',
      onlyFinalApprovercanApprovePSSR: 'Only Final Approver can approve PSSR',
      onlyPSSRTeamLeadClosePSSR: 'Only PSSR Team Lead can close PSSR',
    },
  },
  pdfDialog: {
    header: 'Attach PDF File',
    selectTypePrompt: 'How would you like to attach this PDF?',
    document: 'Document',
    image: 'Image',
    selectPagesTitle: 'Select the pages to convert to images',
    allPages: 'All pages',
    selectPages: 'Select pages',
    page: 'Page',
    select: 'Select',
    couldNotDetectPages: 'Could not detect the page count. All pages will be included.',
  },
  attachmentUpload: {
    title: 'Attach File',
    selectType: 'What would you like to attach?',
    types: {
      link: 'Link',
      document: 'Document',
      image: 'Image',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://example.com',
    },
    clickToSelect: 'Click to select a file',
    acceptedImageTypes: 'Accepted formats: JPG, PNG, GIF, etc.',
    acceptedDocumentTypes: 'Accepted formats: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Upload',
    successMessage: 'File attached successfully',
    sections: {
      images: 'Images',
      documents: 'Documents',
      links: 'Links',
    },
    uploaded: 'Uploaded',
    download: 'Download',
  },
  participants: {
    title: 'Participants',
    addParticipant: 'add participant',
    addMember: 'Add member',
    pssrTeamLead: '{{pssrTitle}} Team Lead',
    pssrTeam: '{{pssrTitle}} Team',
    projectManagers: 'Project Managers',
    projectTeamMembers: 'Project Team Members',
    operationsRepresentative: 'Operations Representative',
    finalApprover: 'Final Approver',
    actionItemAssignee: 'Action Item Assignee',
    noParticipantsAdded: 'No participants added',
    signedBy: 'signed by',
    signedInBehalfOf: 'signed in behalf of',
    signedOn: 'signed on',
  },
  qaqcImport: {
    title: 'QAQC Import',
    milestone: 'QAQC Milestone',
    workOrders: 'QAQC Work Orders',
    milestoneWorkOrders: 'QAQC Milestone\'s Work Orders (optional)',
    milestoneWorkOrdersLabel: 'QAQC Milestone\'s Work Orders',
    milestoneWorkOrdersMessage: 'Please select 1 milestone to view work orders within that milestone',
    noItemsAvailable: 'No available milestones/workorders from QAQC',
    noWorkOrdersForMilestone: 'No work orders available for this milestone',
    unableLoadItems: 'Unable to reach qaqc system for milestones/workorders, please try again later',
    loadEventsError: 'Error getting {{eventLabel}} from QAQC',
    multipleMilestonesWarning: 'Please select 1 milestone to view work orders within that milestone',
    generatePssrTitle: 'Generate PSSR Title',
    alreadyExists: 'This QAQC event already exists as a project',
    selectEvent: 'Project',
    sections: 'Sections',
    assignSectionLeads: 'Assign section leads',
    selectLead: 'Select Lead',
    sectionName: 'Section Name',
    lead: 'Lead',
    template: 'Template',
    type: 'Type',
    projectType: 'Project Type',
    successMessage: 'QAQC Import completed successfully. Project and PSSRs created.',
    errorMessage: 'Error creating QAQC project. Please try again.',
    projectCreatedWithoutItems:
      'Project created. QAQC has no milestones or work orders yet; use "Load New QA QC Items" when they become available.',
    partialErrorMessage:
      'The project was created, but its PSSRs could not be created. Use "Load New QA QC Items" to try again.',
    somePssrsNotCreated:
      'Only {{created}} of {{total}} PSSRs were created. Use "Load New QA QC Items" to create the rest.',
  },
  participantDialog: {
    title: 'Select participant',
    addParticipant: 'Add Participant',
    selectUserType: 'Select user type',
    selectedUserType: 'Selected user type',
    chevronDirectory: 'chevron directory/shared users',
    newNonChevron: 'new non-chevron',
    searchPlaceholder: 'Search by email...',
    emailPlaceholder: 'Enter email...',
    namePlaceholder: 'Enter name...',
    selectRole: 'Select role',
    selectedRole: 'Selected role',
    selectOne: 'select one',
    add: 'add',
    stagedParticipants: 'to be added:',
    batchLimitReached: '{{limit}} user limit reached, please select add',
    alreadyStagedError: 'this user is already in the list',
    successMessage: 'Participant added successfully',
    added: 'Participant added successfully',
    addError: 'Error adding participant',
    alreadyParticipantPssr: 'This user is already a participant of this PSSR as {{role}}',
    alreadyMemberProject: 'This user is already a member of this project as {{role}}',
  },
  participantEditDialog: {
    title: 'Edit participant',
    user: 'User',
    selectRole: 'Select role',
    delete: 'delete',
    captureSignature: 'capture signature',
    recaptureSignature: 're-capture signature',
    removeSignature: 'remove signature',
    removeSignatureSuccess: 'Signature removed successfully',
    save: 'save',
    noSignature: 'No signature captured',
    successMessage: 'Participant updated successfully',
    deleteSuccessMessage: 'Participant removed successfully',
    deleteConfirmHeader: 'Delete Participant',
    deleteConfirmMessage: 'Are you sure you want to remove this participant?',
  },
  buAdminsList: {
    title: 'BU Users Admins',
    actions: {
      addNewUser: 'add admin user',
      delete: 'delete',
    },
    table: {
      fullName: 'full name',
      email: 'email',
    },
    noAdmins: 'No admin users available',
  },
  externalUserForm: {
    labels: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      userNameEmail: 'Email or user name',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Shared User Group',
      sharedEmail: 'Shared Email',
    },
    actions: {
      addChildUser: 'add user',
      importSharedUsers: 'Import Shared Users',
    },
    whitePages: {
      title: 'White Pages Integration',
      description: `Use this type of shared email if you need to sync with White Pages.
          The list of users will be updated automatically over time. Some users may be automatically added or removed
          from this shared email.`,
    },
    customConfiguration: {
      title: 'Custom Configuration',
      description: 'Manually manage the list of users.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Location',
    details: 'Details',
    emptyMessage: 'No PSSRs found',
    filters: {
      businessUnit: 'Business Unit',
      organization: 'Organization',
      area: 'Area',
      subArea: 'Sub Area',
      facilityOperationTeam: 'Facility Operation Team',
      facility: 'Facility',
      project: 'Project',
      template: 'Template',
      selectOne: 'select one',
      status: 'Status',
      type: 'Type',
      deletedStagnant: 'Deleted/Stagnant',
      showOnlyDeleted: 'show only deleted pssrs',
      showOnlyStagnant: 'show only stagnant pssrs',
      userSearch: 'User Search',
      placeholderUserSearch: 'sample text',
      search: 'Search',
      placeholderSearch: 'search for pssr by moc wo, pssr id, title, etc...',
      isStagnant: 'Is Stagnant',
      isDeleted: 'Is Deleted',
    },
    buttons: {
      clearFilter: 'clear filter',
      newPssr: 'new PSSR',
      viewItems: 'view items',
      open: 'open',
    },
    actions: {
      clearFilter: 'Clear Filter',
      newPssr: 'new pssr',
      importPssr: 'import pssr',
    },
    table: {
      id: 'ID',
      title: 'Title',
      type: 'Type',
      status: 'Status',
      facility: 'Facility',
      project: 'Project',
    },
    statusOptions: {
      draft: 'Draft',
      initiated: 'Initiated',
      inProgress: 'In Progress',
      completed: 'Completed',
      pendingApproval: 'Pending Approval',
      approved: 'Approved',
      closed: 'Closed',
    },
    noPssrs: 'No PSSRs available',
  },
  pssrListItem: {
    pssrId: 'PSSR ID',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Project',
    teamLeads: 'Team Leads',
    totalQuestions: 'Total Questions',
    outstandingQuestions: 'Outstanding Questions',
    completedQuestions: 'Completed Questions',
    area: 'Area',
    subArea: 'Sub Area',
    facility: 'Facility',
    qaqcStatus: 'status',
    qaqcMilestone: 'QA QC Milestone',
    qaqcWorkOrder: 'QA QC WorkOrder',
    qaqcReady: '% ready',
    qaqcComplete: '% complete',
    qaqcAccepted: '% accepted',
    qaqcSignatures: 'signatures',
    qaqcDocuments: 'QA QC Documents',
    qaqcNoData: 'no QA QC data',
  },
  pssrStatuses: {
    Draft: 'Draft',
    Initiated: 'Initiated',
    InProgress: 'In Progress',
    Completed: 'Completed',
    PendingApproval: 'Pending Approval',
    Approved: 'Approved',
    Closed: 'Closed',
    Deleted: 'Deleted',
    CreateDate: 'Draft Created On',
    InitiatedOn: 'Initiated',
    StartedOn: 'Started',
    CompletedOn: 'Walkdown Completed On',
    PendingApprovalOn: 'Pending Approval Submitted On',
    ApprovedOn: 'Approved On',
    ClosedOn: 'Closed On',
    DeletedOn: 'Deleted On',
    RestoredOn: 'Restored On',
  },
  signatureCaptureDialog: {
    title: 'Capture Signature',
    confirm: 'confirm',
    saveSuccess: 'Signature captured successfully',
  },
  projectsList: {
    title: 'Projects',
    table: {
      projectName: 'Project name',
      projectManager: 'Project manager',
      status: 'Status',
      completedTotalPssrs: 'Completed/total pssrs',
      actions: 'Actions',
      dateCreated: 'Date created',
    },
    statusLabels: {
      active: 'active',
      closed: 'closed',
    },
    sort: {
      placeholder: 'Sort by',
      nameAsc: 'Name (A-Z)',
      nameDesc: 'Name (Z-A)',
      statusAsc: 'Status (Low to High)',
      statusDesc: 'Status (High to Low)',
      dateAsc: 'Date Created (Oldest First)',
      dateDesc: 'Date Created (Newest First)',
    },
    actions: {
      open: 'open',
      createProject: 'create project',
    },
    projectSearch: 'Project Search',
    showDeletedProjects: 'Show Deleted Projects',
    searchPlaceholder: 'Search by name, ID, or description',
    datePlaceholder: 'mm/dd/yyyy - mm/dd/yyyy',
    statusPlaceholder: 'select one',
    noProjects: 'No projects available',
  },
  projectEdit: {
    title: 'Edit Project',
    projectName: 'Project Name',
    projectNamePlaceholder: 'Enter project name',
    statusActive: 'active',
    statusClosed: 'closed',
    statusDeleted: 'deleted',
    teamMembers: 'Team Members',
    addParticipant: 'add participant',
    pssrCcc: 'PSSR/CCC',
    newPssr: 'New {{pssrTitle}}',
    noPssrCcc: 'There are no PSSR/CCCs associated with this project.',
    delete: 'Delete',
    markAsClosed: 'Mark as closed',
    reopen: 'Reopen',
    confirmDelete: 'Are you sure you want to delete this project?',
    confirmDeleteHeader: 'Confirm Delete',
    confirmDeletePssrs: 'Do you also want to delete all PSSRs associated with this project?',
    confirmDeletePssrsHeader: 'Delete PSSRs?',
    deleteSuccess: 'Project deleted successfully',
    confirmMarkAsClosed: 'Are you sure you want to mark this project as closed?',
    confirmMarkAsClosedHeader: 'Confirm Mark as Closed',
    markedAsClosedSuccess: 'Project marked as closed successfully',
    confirmCloseProjectTitle: 'Confirm Close Project',
    confirmCloseProjectDescription: 'Are you sure you want to mark this project as closed?',
    confirmReopenProjectTitle: 'Confirm Reopen Project',
    confirmReopenProjectDescription: 'Are you sure you want to reopen this project?',
    cannotCloseProjectDueOpenPSSRs: 'Cannot close the project because there are open PSSRs.',
    projectUpdatedSuccessfully: 'Project updated successfully',
    loadNewQaqcItems: 'Load New QA QC Items',
    qaqcItemsLoadedSuccessfully: 'New QAQC items loaded successfully',
    qaqcItemsUpToDate: 'QAQC items are already up to date',
    qaqcInputWarning: 'Please complete the required QAQC fields before loading new items: {{fields}}.',
    initiateAll: 'Initiate All PSSRs',
    initiateAllTitle: 'Initiate All PSSRs',
    initiateAllDescription: 'Do you want to initiate all PSSRs of this project?',
    initiateAllSuccess: 'All PSSRs were initiated successfully',
    initiateAllPartialError: 'Some PSSRs could not be initiated:',
    projectReopenedSuccessfully: 'Project reopened successfully',
    restorePssr: 'Restore',
    confirmRestoreProject: 'Are you sure you want to restore this project?',
    confirmRestoreProjectHeader: 'Confirm Restore',
    restoreSuccess: 'Project restored successfully',
    deleteDialog: {
      title: 'Confirm Project Deletion',
      confirmDeleteWithPssrs:
        'The following action could delete the Project and the PSSRs involved. Would you like to continue?',
      confirmDeleteWithoutPssrs: 'Would you like to proceed?',
      deleteProjectAndPssrs: 'Delete Project & PSSRs',
      deleteProjectOnly: 'Delete Project Only',
      deleteSuccess: 'Project deleted successfully',
      deleteError: 'Error deleting project',
    },
    cascadeDialog: {
      cascade: 'cascade',
      title: 'Cascade Roles',
      description: 'Select the participants you want to cascade to all PSSRs for this project.',
      teamLeads: 'Team Leads',
      teamMembers: 'Team Members',
      operationsRepresentative: 'Operations Representative',
      finalApprover: 'Final Approver',
      apply: 'apply',
      success: 'Roles cascaded successfully',
    },
    errors: {
      noPermissionToEditParticipants: 'You do not have permission to edit participants in this project',
    },
  },
  multiselect: {
    selectedItems: '{0} items selected',
    placeholder: 'choose',
  },
  support: {
    title: 'Feedback',
    buSupportInfo: 'ePSSR BU Support Information',
    serviceNowInstructions: 'ePSSR Service Now Ticketing Instructions',
    instructions: {
      step1: 'Go to the {{serviceNowLink}} Form in the Chevron IT Service Portal',
      step1LinkText: 'Application Support Request',
      step2: 'Under the Application Field select <b>Mobile PSSR</b>.',
      step3:
        'To report an issue or bug please select <b>Report an Issue</b>. To submit an enhancement request or user access request please select <b>Service Request</b>. Hit Next.',
    },
    reportIssue: {
      title: 'Report an Issue',
      step1: 'Fill out the Description of the Problem, Impact and Urgency.',
      step2: 'Press Next and then Submit.',
      step3: 'The ePSSR Support Team will acknowledge the receipt of the ticket in 24 hours during business hours.',
    },
    enhancement: {
      title: 'Enhancement Request',
      step1: 'Please select <b>Enhancements</b> under Type of Requests.',
      step2: 'Select Priority (<b>Low, Moderate, High</b>)',
      step3: 'Fill out the Description of Request',
      step4: 'Select Next and Submit.',
      step5:
        'The ePSSR Support Team will review enhancement requests as part of the Surface Digital PI Planning Process',
    },
    userAccess: {
      title: 'User Access Request',
      step1: 'Please select <b>Request Access</b> under Type of Requests.',
      step2: 'Select Access Request Type (<b>Add or Remove</b>)',
      step3: 'Select a user',
      step4: 'Select Priority (<b>Low, Moderate, High</b>)',
      step5: 'Specify Role and Access the User needs.',
      step6: 'Select Next and Submit.',
      step7: 'The ePSSR Support Team will acknowledge the receipt of the ticket in 24 hours during business hours.',
    },
  },
  datepicker: {
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Wk',
  },
  errors: {
    unauthorized: {
      title: 'Unauthorized Access',
      message: 'You do not have permission to access this page.',
    },
    serverError: {
      title: 'Server Error',
      message: 'An unexpected error occurred. Please try again later.',
    },
    pageNotFound: {
      title: 'Page Not Found',
      message: 'The page you are looking for does not exist.',
    },
    actions: {
      returnHome: 'Return to Home',
    },
  },
  attachments: {
    sections: {
      images: 'Images',
      documents: 'Documents',
      links: 'Links',
    },
    actions: {
      download: 'Download',
      delete: 'Delete',
    },
    labels: {
      uploaded: 'Uploaded',
    },
  },
  imagePreview: {
    errorMessage: 'Failed to load image',
    errorDetails: 'Check browser console for details',
  },
  functionalReview: {
    audit: {
      createdBy: 'Created by',
      updatedDate: 'Updated Date',
      updatedBy: 'Updated by',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      orderedList: 'Ordered List',
      unorderedList: 'Unordered List',
      codeBlock: 'Code Block',
      blockQuote: 'Block Quote',
    },
    alignment: {
      center: 'center',
      right: 'right',
      justify: 'justify',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Remove user',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Remove',
    },
  },
  progressBar: {
    label: 'Progress:',
  },
  categories: {
    dialogs: {
      addCategory: 'Add category',
      editCategory: 'Edit category',
      createSubCategory: 'Create new subcategory',
      editSubCategory: 'Edit subcategory',
    },
    placeholders: {
      subcategoryName: 'Subcategory name',
    },
  },
  categoriesList: {
    title: 'Categories',
    hideInactiveItems: 'Hide inactive categories',
    subCategoryName: 'Sub category name',
    inactive: '(inactive)',
    noSubcategories: 'No subcategories',
    selectHeader: 'Select',
    actions: {
      createSubCategory: 'Create new subcategory',
      restore: 'Restore',
      add: 'Add',
      addSubCategories: 'Add subcategories',
      remove: 'Remove',
    },
    deleteDisabledTooltip: 'This category cannot be deleted because it contains active subcategories',
    dialogs: {
      addSubCategoriesHeader: 'Add subcategories',
      deleteCategoryHeader: 'Attention',
      deleteCategoryMessage: 'Are you sure you want to delete Category: [{{name}}]?',
      deleteSubCategoryHeader: 'Attention',
      deleteSubCategoryMessage: 'Remove [{{name}}] from category [{{category}}]? The subcategory itself will not be deleted.',
    },
    validation: {
      subCategoryExists: 'A subcategory with this name already exists',
      categoryExists: 'A category with this name already exists',
    },
  },
};
export default en;
